export default __webpack_public_path__ + "static/media/sindromes_aorticos_agudos.986daeb7.pdf";